var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHalborn = function SvgHalborn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.024.222c0 .061-1.977 4.06-4.393 8.884L3.238 17.88H1.756c-.814 0-1.537-.092-1.606-.203C.036 17.492 8.13 1.016 8.648.379c.21-.26 3.376-.406 3.376-.157Zm8.124.157c-.005.147-1.957 4.12-4.336 8.83l-4.326 8.563-1.368.064c-.752.036-1.5.014-1.66-.048-.215-.082.894-2.488 4.098-8.895L16.95.111h1.604c1.148 0 1.603.076 1.595.268Z",
    fill: "currentColor"
  })));
};
export default SvgHalborn;